//import { defineCustomElement } from 'vue'

//import AccountSummary from './components/AccountSummary.vue';
//import PageToolbar from './components/PageToolbar.vue';
import HowIsIt from './components/HowIsIt.vue';
//import QueryApp from './components/QueryApp.vue';
//import SignInSignOut from './components/SignInSignOut.vue';
import WeatherSummaryComponent from './components/WeatherSummary.vue';
import WeatherSummary2Component from './components/WeatherSummary2.vue';
//import EnergyComponent from './components/EnergyComponent.vue';
import WinterTrackerComponent from './components/WinterTrackerComponent.vue';
//import { createMemoryHistory, createRouter } from 'vue-router';

// Import our custom CSS
import './scss/styles.scss'
import './wxwidgets/wxwidgets.scss'
// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
console.log("loading main-dashboardcomponents..." );

//import { createApp } from 'vue'

//export { createApp, WeatherSummary2Component };

//createApp(WeatherSummary2Component).mount('#app')


let VcComponentLoader = (function(){
    console.log("Starting VcDashboardComponentLoader..." );
    const COMPONENTS={
       // 'AccountSummary':AccountSummary,
        'HowIsIt':HowIsIt,
        //'PageToolbar':PageToolbar,
        //'QueryApp':QueryApp,
        //'SignInSignOut':SignInSignOut,
        'WinterTrackerComponent':WinterTrackerComponent,
        'WeatherSummaryComponent':WeatherSummaryComponent,
        'WeatherSummary2Component':WeatherSummary2Component,
        
    };

    window.VcAvailableComponents=(window.VcAvailableComponents && { ...window.VcAvailableComponents, ...COMPONENTS }) || COMPONENTS;
    /*
    let isReady=false;

    window.addEventListener("load",function(event) {
        isReady=true;

        attachComponents();
        
    },false);
   
    function attachComponents() {
        if (!window.VcComponents) {
            console.log("No VcComponents found..." );
            return;
        }

        window.VcComponents.forEach(item => {
            if (!COMPONENTS[item.component]) {
                console.log("Component not found..." +item.component);
                return;
            }
            console.log("Component being mounted..." +item.component);
            createApp(COMPONENTS[item.component]).mount(item.selector)
        });
    }
        */
})();



